import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import CadastrarRadiologia from '../../components/Ortodontia/CadastrarRadiologia'

const mapStateToProps = (store) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CadastrarRadiologia)
